import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import PrintableEnquiryForm from "./PrintableEnquiryForm";
import Loader from "../../Loader/Loader";
import { getAllStudents } from "../../api/Api"; // Assuming we can fetch by ID or filter. Better if there is getEnquiryById

const PrintEnquiryPage = () => {
    const { id } = useParams();
    const [enquiryData, setEnquiryData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Since there might not be a direct getById, we fetch all and find. 
                // Optimization: If getAllStudents is heavy, check if getEnquiryById exists later.
                const response = await getAllStudents();
                if (response.data) {
                    const found = response.data.find(item => item._id === id);
                    if (found) {
                        setEnquiryData(found);
                    } else {
                        console.error("Enquiry not found");
                    }
                }
            } catch (error) {
                console.error("Error fetching enquiry:", error);
            } finally {
                setLoading(false);
            }
        };

        if (id) {
            fetchData();
        }
    }, [id]);

    useEffect(() => {
        if (!loading && enquiryData) {
            // Trigger print once data is loaded
            window.print();
        }
    }, [loading, enquiryData]);

    if (loading) return <div className="flex justify-center items-center h-screen"><Loader /></div>;
    if (!enquiryData) return <div className="text-center p-10">Enquiry not found.</div>;

    return (
        <div className="bg-white min-h-screen">
             <PrintableEnquiryForm data={enquiryData} />
        </div>
    );
};

export default PrintEnquiryPage;
